const UserFundBox = require('./UserFundBox');
const PublicUserFundBox = require('./PublicUserFundBox');

module.exports = {
    UserFundBox,
    PublicUserFundBox
}
